export enum PlatformEventEvents {
    AddressUpdatePending = 'address-update-pending',
    AddressUpdated = 'address-updated',
}
